import { render, staticRenderFns } from "./DevHeader.vue?vue&type=template&id=468e78db&"
import script from "./DevHeader.vue?vue&type=script&lang=js&"
export * from "./DevHeader.vue?vue&type=script&lang=js&"
import style0 from "./DevHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports